<template lang="pug">
  .d-flex.align-center
    phone-input(:value="value" ref="phoneInput" @input="$emit('input', $event)" @error="handlePhoneError" @changeCountry="$emit('changeCountry', $event)")
    template(v-if="!isReset")
      template(v-if="isLoading")
        v-progress-circular.mb-4(indeterminate size="35" color="info500")
      template(v-else-if="!isError")
        template(v-if="isNewCustomer")
          y-chip.info100.mb-2 New
        template(v-else)
          v-icon.pb-2(color="success") $yzi-check-circle
</template>

<script>

import PhoneInput from "@/components/marketing/merchantapp/collect/PhoneInput.vue";

export default {
  components: {
    PhoneInput
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    dialNumber: {
      type: String,
      default: ''
    },
    isReset: {
      type: Boolean,
    },
    isLoading: {
      type: Boolean,
    },
    isNewCustomer: {
      type: Boolean,
    }
  },
  data() {
    return {
      isError: true
    }
  },
  watch: {
    dialNumber(value) {
      this.$refs.phoneInput.dialNumber = value
    }
  },
  methods: {
    handlePhoneError(value) {
      this.isError = value
      this.$emit('error', value)
    }
  },
}
</script>

<style scoped>
</style>